<script>
	export default {
		name: 'FileExecuter',
		methods: {
			readFile(file) {
				let reader_ = new FileReader()
				reader_.readAsText(file)

				return new Promise(resolve => {
					reader_.onload = () => { resolve(reader_.result) }
				})
			},
			getFileList(path) {
				const self_ = this;

				const ref_ = self_.firebase.storage().ref().child(path)

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return ref_.listAll()
					}).then(result => {
						let result_ = []
						result.items.forEach(key => {
							result_.push(key.name)
						})
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			uploadFileText(path, name, file) {
				const self_ = this;

				const ref_ = self_.firebase.storage().ref()
				const upload_ = ref_.child(path + '/' + name)

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_fileExec_makeDataUrl(file)
					}).then(result => {
						// firebase functions returns error
						// firebase Storage: String does not match format 'base64': Invalid character found

						// const body_ = {
						// 		name: name,
						// 		dataUrl: result
						// }
						// return self_.callFunction('storageFunction', 'upload', { body: body_ })

						return upload_.putString(result, 'data_url')
					}).then(() => {
						return upload_.getDownloadURL()
					}).then(result => {
						resolve({ name: name, url: result })
					}).catch(error => {
						reject(error)
					})
				})
			},
			uploadFileImage(path, name, file) {
				const self_ = this;

				const ref_ = self_.firebase.storage().ref()
				const upload_ = ref_.child(path + '/' + name);

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_fileExec_makeDataUrl(file)
					}).then(result => {
						// firebase functions returns error
						// firebase Storage: String does not match format 'base64': Invalid character found

						// const body_ = {
						// 		name: file.name,
						// 		dataUrl: result
						// }
						// return self_.callFunction('storageFunction', 'compressAndUpload', { body: body_ })

						const body_ = {
							name: name,
							dataUrl: result
						}

						return self_.callFunction('storageFunction', 'compress', { body: body_ })
					}).then(result => {
						return upload_.putString(result, 'base64')
					}).then(() => {
						return upload_.getDownloadURL()
					}).then(result => {
						resolve({ name: name, url: result })
					}).catch(error => {
						reject(error)
					})
				})
			},
			uploadFileOther(path, name, file) { // only direct upload for other file
				const self_ = this;

				const ref_ = self_.firebase.storage().ref()
				const upload_ = ref_.child(path + '/' + name)

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return upload_.put(file)
					}).then(() => {
						return upload_.getDownloadURL()
					}).then(result => {
						resolve({ name: file.name, url: result })
					}).catch(error => {
						reject(error)
					})
				})
			},
			downloadFile(path, name) {
				const self_ = this;

				const ref_ = self_.firebase.storage().ref()
				const download_ = ref_.child(path + '/' + name)

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return download_.getDownloadURL()
					}).then(result => {
						resolve({ name: name, url: result })
					}).catch(error => {
						console.log(error);
					})
				})
			},
			$_fileExec_makeDataUrl(file) {
				return new Promise(resolve => {
					let reader_ = new FileReader()
					reader_.readAsDataURL(file)
					reader_.onload = () => {
						resolve(reader_.result)
					}
				})
			}
		}
	}
</script>
